import { CircleLoader } from '@/components/loader/CircleLoader.jsx'
import { getSubscriptionOfAccount } from '@/services/api.js'
import { toast } from 'sonner'
import { handleError } from '@/services/errorHandler.js'
import { useEffect } from 'react'
import { usePaymentContext } from '@/context-state/PaymentContext.jsx'
import { toggleVerifyPayment } from '@/hooks/useVerifyPayment.jsx'

// Verify Paddle payments, we poll the subscription status from the backend since we wait for the webhook to arrive (usually around 2-3 seconds)
export const VerifyPayment = () => {

    const { setSubscription } = usePaymentContext()

    const pollNewSubscriptionStatus = async () => {
        try {
            // Poll it the dumb way...
            for (let i = 0; i < 50; i++) {
                await new Promise(resolve => setTimeout(resolve, 1000))
                const { data } = await getSubscriptionOfAccount()
                const sessionId = localStorage.getItem('paddleSessionId')
                if (data?.sessionId === sessionId) {
                    localStorage.removeItem('paddleSessionId')
                    setSubscription(data)
                    toast.success('Payment Verified! New subscription applied!🎉')
                    toggleVerifyPayment(false)
                    break
                }
            }
        } catch (e) {
            handleError(e)
            toast.error(e.message)
            console.error(e)
            toggleVerifyPayment(false)
        }
    }

    useEffect(() => {
        pollNewSubscriptionStatus()
    }, [])

    return (
        <div className="fixed left-0 top-0 bg-background/70 w-full h-screen z-[9999] flex flex-col items-center justify-center gap-4">
            <CircleLoader />
            Verifying Payment...
        </div>
    )
}